import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {AppComponent} from './app.component';
import {AppRoutingModule} from './app-routing.module';
import {reducerProvider, reducerToken, effects, LOGOUT_USER} from './store';
import {CustomSerializer} from './store/reducers/router.reducer';
import {StoreDevtoolsModule} from '@ngrx/store-devtools';
import {EffectsModule} from '@ngrx/effects';
import {RouterStateSerializer, StoreRouterConnectingModule} from '@ngrx/router-store';
import {ToastrModule} from 'ngx-toastr';
import {StoreModule, ActionReducer, MetaReducer} from '@ngrx/store';
import {HttpClientModule} from '@angular/common/http';
import {NgbDateParserFormatter, NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {LoadingBarHttpClientModule} from '@ngx-loading-bar/http-client';
import {environment} from '../environments/environment';
import {NgbDateUsFormatter} from './shared/ngb-date-us-formatter';
import {JwtModule} from '@auth0/angular-jwt';
import {CoreModule} from './shared/core.module';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';


export function rootReducer(reducer: ActionReducer<any>): ActionReducer<any> {
  return function (state, action) {
    switch (action.type) {
      case LOGOUT_USER:
        state = undefined;
    }
    return reducer(state, action);
  };
}

export const metaReducers: MetaReducer<any>[] = [rootReducer];

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    AppRoutingModule,
    BrowserModule,
    BrowserAnimationsModule,
    CoreModule,
    HttpClientModule,
    NgbModule.forRoot(),
    ToastrModule.forRoot(),
    StoreModule.forRoot(reducerToken, {metaReducers}),
    EffectsModule.forRoot(effects),
    CoreModule,
    LoadingBarHttpClientModule,
    StoreRouterConnectingModule,
    environment.production ? [] : StoreDevtoolsModule.instrument({
      maxAge: 25, // Retains last 25 states
    }),
    JwtModule.forRoot({
      config: {
        tokenGetter: tokenGetter,
        whitelistedDomains: environment.whitelistedDomains
      }
    })
  ],
  providers: [{
    provide: RouterStateSerializer,
    useClass: CustomSerializer
  }, reducerProvider, {provide: NgbDateParserFormatter, useClass: NgbDateUsFormatter}],
  bootstrap: [AppComponent]
})
export class AppModule {
}

export function tokenGetter() {
  return localStorage.getItem('token');
}



// WEBPACK FOOTER //
// /Users/bitcot/Projects/PouredHQ/getpoured-popup-angular/src/app/app.module.ts